/**
 * 金额小写转大写（人民币）
 * 输入：数字字符串，如 "1234.56"
 * 输出：大写字符串，如 "壹仟贰佰叁拾肆元伍角陆分"
 */
export function amountToUppercase(numStr: string): string {
  const s = String(numStr).replace(/,/g, '').trim();
  if (!s || isNaN(Number(s))) return '';

  const digitUppercase = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unitInteger = ['', '拾', '佰', '仟'];
  const unitSection = ['', '万', '亿', '兆'];

  // 处理小数部分（角分）
  let [intPart, decPart = ''] = s.split('.');
  intPart = intPart.replace(/^0+/, '') || '0';
  decPart = (decPart + '00').substring(0, 2);

  // 整数部分
  let result = '';
  if (intPart === '0') {
    result = '零元';
  } else {
    // 按4位一组分割
    const sections: string[] = [];
    let tmp = intPart;
    while (tmp.length > 0) {
      sections.unshift(tmp.substring(Math.max(0, tmp.length - 4), tmp.length));
      tmp = tmp.substring(0, Math.max(0, tmp.length - 4));
    }

    for (let i = 0; i < sections.length; i++) {
      const sec = sections[i];
      let secStr = '';
      let zeroFlag = false;
      for (let j = 0; j < sec.length; j++) {
        const d = parseInt(sec[j]);
        const unit = unitInteger[sec.length - 1 - j];
        if (d === 0) {
          zeroFlag = true;
        } else {
          if (zeroFlag) { secStr += '零'; zeroFlag = false; }
          secStr += digitUppercase[d] + unit;
        }
      }
      if (secStr !== '' || (i === sections.length - 1 && result === '')) {
        result += secStr + unitSection[sections.length - 1 - i];
      } else if (secStr !== '') {
        result += secStr + unitSection[sections.length - 1 - i];
      } else if (zeroFlag) {
        // 整节为0，不加单位
      }
      if (secStr === '' && i < sections.length - 1) {
        // 该节全0，加零
        if (!result.endsWith('零')) result += '零';
      }
    }
    result += '元';
  }

  // 小数部分
  const jiao = parseInt(decPart[0]);
  const fen = parseInt(decPart[1]);

  if (jiao === 0 && fen === 0) {
    result += '整';
  } else {
    if (jiao > 0) {
      result += digitUppercase[jiao] + '角';
    } else {
      result += '零';
    }
    if (fen > 0) {
      result += digitUppercase[fen] + '分';
    }
  }

  return result;
}

/**
 * 计算采购明细金额 = 数量 × 单价
 */
export function calcAmount(quantity: string, unitPrice: string): string {
  const q = parseFloat(quantity);
  const p = parseFloat(unitPrice);
  if (isNaN(q) || isNaN(p)) return '';
  return (q * p).toFixed(2);
}

/**
 * 计算采购明细总金额
 */
export function calcTotalAmount(items: { 数量: string; 单价: string; 金额: string }[]): string {
  let total = 0;
  for (const item of items) {
    const a = parseFloat(item.金额) || 0;
    total += a;
  }
  return total.toFixed(2);
}
